/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
  Snackbar,
} from '@mui/material';
import { spacing } from '@mui/system';
import axios from '../../CustomAxios';
import Loading from '../components/Loading';

const Card = styled(MuiCard)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const SettingsPage = ({ auths }) => {
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [settings, setSettings] = useState({ hsn_code: '' });
  const [formData, setFormData] = useState({ hsn_code: '' });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const authData = JSON.parse(localStorage.getItem('AuthData'));
  const userType = authData?.type; // 'super_admin' or 'ap_user'

  // Fetch current settings
  const fetchSettings = async () => {
    try {
      setLoading(true);
      const config = {
        headers: { Authorization: `Bearer ${authData.access_token}` },
      };
      const response = await axios.get(
        `/api/v1/${userType}/settings`,
        config
      );
      if (response.data.success) {
        setSettings(response.data.data);
        setFormData({
          hsn_code: response.data.data.hsn_code || '',
        });
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      setSnackbar({
        open: true,
        message: 'Failed to load settings',
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  // Update settings
  const updateSettings = async () => {
    try {
      setUpdating(true);
      const config = {
        headers: { Authorization: `Bearer ${authData.access_token}` },
      };
      const payload = {};
      if (formData.hsn_code !== undefined) payload.hsn_code = formData.hsn_code;

      const response = await axios.put(
        `/api/v1/${userType}/settings`,
        payload,
        config
      );
      if (response.data.success) {
        setSettings(response.data.data);
        setSnackbar({
          open: true,
          message: 'Settings updated successfully',
          severity: 'success',
        });
      }
    } catch (error) {
      console.error('Error updating settings:', error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || 'Failed to update settings',
        severity: 'error',
      });
    } finally {
      setUpdating(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateSettings();
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      <Helmet title="Settings | Alpha Plus" />
      <Grid container justifyContent="space-between" alignItems="center" mb={4}>
        <Grid item>
          <Typography
            variant="h4"
            gutterBottom
            display="inline"
            sx={{ fontWeight: 600 }}
            color="primary"
          >
            Settings
          </Typography>
        </Grid>
        <Grid item>
          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/dashboard/tasks">
              Dashboard
            </Link>
            <Typography>Settings</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

      <Card mb={6}>
        <CardContent>
          <Paper style={{ padding: '2%' }}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="HSN Code"
                    name="hsn_code"
                    value={formData.hsn_code || ''}
                    onChange={handleChange}
                    variant="outlined"
                    helperText="Comma-separated or single HSN code (if applicable)"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={updating}
                  >
                    {updating ? 'Saving...' : 'Save Changes'}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </CardContent>
      </Card>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(SettingsPage);